import { all, call, fork, put, takeLatest, getContext, select } from 'redux-saga/effects';
import * as actions from './actions';
import { logout } from '../auth/actions';
import { getAgencies, getAgency, getAgencyAliases } from '../../api/api';
import { AgencyActionTypes } from './types';
import { getUniId } from '../selectors';

function* handleGetAgencies() {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);

    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetAgencies');
      return;
    }

    const response = yield call(getAgencies, idToken);

    if (response.name === 'Error') {
      throw new Error(response.stack);
    }

    yield put(actions.getAgenciesSuccess(response));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getAgenciesFailure(err.message));
    } else {
      yield put(actions.getAgenciesFailure('An unknown error occured.'));
    }
  }
}

function* handleGetAgencyById(action: ReturnType<typeof actions.getAgencyById>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetAgencyById');
      return;
    }

    const { agencyId, checkApplyAccess } = action.payload;
    const response = yield call(getAgency, idToken, agencyId, checkApplyAccess);

    yield put(actions.getAgencyByIdSuccess(response));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getAgencyByIdFailure(err.message));
    } else {
      yield put(actions.getAgencyByIdFailure('An unknown error occured.'));
    }
  }
}

function* handleGetAgencyAliases() {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetAgencyAliases');
      return;
    }

    const university = yield select(getUniId);
    const response = yield call(getAgencyAliases, idToken, university);

    if (response.name === 'Error') {
      throw new Error(response.stack);
    }

    yield put(actions.getAgentAliasesSuccess(response));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getAgentAliasesFailure(err.message));
    } else {
      yield put(actions.getAgentAliasesFailure('An unknown error occurred.'));
    }
  }
}

function* watchGetAgencies() {
  yield takeLatest(AgencyActionTypes.GET_AGENCIES, handleGetAgencies);
}

function* watchGetAgencyById() {
  yield takeLatest(AgencyActionTypes.GET_AGENCY_BY_ID, handleGetAgencyById);
}

function* watchGetAgencyAliases() {
  yield takeLatest(AgencyActionTypes.GET_AGENT_ALIASES, handleGetAgencyAliases);
}

function* AgencySaga() {
  yield all([fork(watchGetAgencies)]);
  yield all([fork(watchGetAgencyById)]);
  yield all([fork(watchGetAgencyAliases)]);
}

export default AgencySaga;
